import axios from "axios";

export const weatherService = async (location) => {
    const url = `https://api.openweathermap.org/data/2.5/weather?q=${location.trim()}&units=metric&appid=229a3e58fd76b4cb632e90a1ff862f76`;

    const response = await axios.get(url);
    return response.data;
    
}

